UserLoginController.$inject = ['$scope','$uibModalInstance','userService']
function UserLoginController($scope, $uibModalInstance,userService){
    $scope.user = {};
    $scope.emailResetPassword = "";
    $scope.showFormNewPassword = false;


    function login(user){
        userService.login(user)
        .then(res =>  $uibModalInstance.close())
    }

    $scope.login = login;
    $scope.requestPasswordReset = userService.requestPasswordReset;
    $scope.togglePasswordResetForm = () => $scope.showFormNewPassword = !$scope.showFormNewPassword
}

UserListController.$inject = ['$scope','userService']
function UserListController($scope, userService){
    $scope.users = [];
    $scope.currentPage = 1;

    function list(){
        userService.find()
        .then((users) => $scope.users = users)
    }

    list()

    $scope.list = list;
}

UserEditController.$inject = ['$scope','$routeParams', 'userService', 'companyService', 'roleService']
function UserEditController($scope, $routeParams, userService, companyService,roleService){
    let userId = $routeParams.id;
    $scope.user = {};
    $scope.user.roles = [];
    $scope.companies = {};

    let promises = [];

    promises.push(userService.get(userId));
    promises.push(companyService.find({}));
    promises.push(roleService.find({}));

    Promise.all(promises)
    .then(result => {
        $scope.user = result[0];
        $scope.companies = result[1];
        $scope.roles = userService.checkUserRoles(result[2], $scope.user);
    })

    $scope.addRole = userService.addRole;
    $scope.update = userService.update;
}

UserNewController.$inject = ['$scope', 'userService', 'companyService', 'roleService'];
function UserNewController($scope, userService, companyService, roleService){
    $scope.user = {};
    $scope.user.roles = [];

    let promises = [];

    promises.push(companyService.find({}));
    promises.push(roleService.find({}));

    Promise.all(promises)
    .then(result => {
        $scope.companies = result[0];
        $scope.roles = result[1];
    })

    $scope.add = userService.add;
}


app.controller('UserLoginController', UserLoginController)
app.controller('UserListController', UserListController)
app.controller('UserNewController', UserNewController)
app.controller('UserEditController', UserEditController)
